import { Droplets, Wind, Flame, Snowflake, ArrowRight } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";

const SERVICES = [
  {
    icon: Droplets,
    title: "Installation PAC Air/Eau",
    features: ["Chauffage central", "Eau chaude sanitaire", "Jusqu'a 70% d'economies", "Eligible aux aides"],
  },
  {
    icon: Wind,
    title: "Installation PAC Air/Air",
    features: ["Chaud et froid", "Installation rapide", "Faible consommation", "Confort immediat"],
  },
  {
    icon: Flame,
    title: "Installation chauffe-eau thermodynamique",
    features: ["3x plus economique", "Ecologique", "Silencieux", "Eligible aux aides"],
  },
  {
    icon: Snowflake,
    title: "Installation climatisation reversible",
    features: ["Mono-split", "Gainable", "Confort 4 saisons", "Chaud et froid"],
  },
];


export default function ServicesSection() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-16 md:py-24 bg-[#F9FAFB]">

      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-12 md:mb-16 scroll-reveal">
          <h2
            className="text-3xl md:text-4xl font-bold tracking-tight text-[#6AB023] mb-4"
            data-testid="services-title">

            Nos services
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">Installation de pompe à chaleur, chauffe-eau et climatisation a Villeneuve-sur-Lot, Casseneuil, Pujols, Fumel et dans tout le Lot-et-Garonne (47).

          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {SERVICES.map((service, idx) => {
            const Icon = service.icon;
            return (
              <Card
                key={service.title}
                className={`scroll-reveal-scale stagger-${idx + 1} service-card bg-white border border-gray-100 rounded-xl overflow-hidden`}
                data-testid={`service-card-${idx}`}>

                <CardContent className="p-6 md:p-8 flex flex-col h-full">
                  <div className="w-14 h-14 bg-green-50 rounded-xl flex items-center justify-center mb-5">
                    <Icon className="w-7 h-7 text-[#6AB023]" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-4">
                    {service.title}
                  </h3>
                  <ul className="space-y-2.5">
                    {service.features.map((feat) =>
                    <li key={feat} className="flex items-center gap-2 text-sm text-gray-700">
                        <ArrowRight className="w-3.5 h-3.5 text-[#6AB023] flex-shrink-0" />
                        {feat}
                      </li>
                    )}
                  </ul>
                </CardContent>
              </Card>);

          })}
        </div>
      </div>
    </section>);

}